import request from '@/router/axios';

export const getList = (params) => {
  return request({
    url: '/api/produce/wagon-tippler-operation-phase-detail/selectPage',
    method: 'get',
    params
  })
}
